export enum AppLogLevel {
  Error,
  Warning,
  Info,
  Debug
}

export enum MessageType {
  Error,
  Warning,
  Info,
  Debug,
  Success = 10
}

export enum eModuleTypes {
  Empty = 0,
  Home = 100,
  DocumentAdd = 200,
  DocumentsAll = 1000,
  DocumentsNotProcessed = 1001,
  DocumentsIn = 1030,
  DocumentsOut = 1035,
  DocumentsProjects = 1040,
  DocumentsProcessed = 1045,
  DocumentsAnnulled = 1050,
  Signs = 2000,
  SignsAll = 2020,
  SignsIn = 2025,
  SignsInSigned = 2030,
  SignsInRejected = 2035,
  SignsOut = 2040,
  SignsOutSigned = 2045,
  SignsOutRejected = 2050,
  SignsNotProcessed = 2055,
  SignsProcessed = 2060,
  SignsRecalling = 2061,
  SignsAnnulled = 2065,
  Agree = 3000,
  AgreeAll = 3020,
  AgreeIn = 3025,
  AgreeInAccepted = 3030,
  AgreeInRejected = 3035,
  AgreeOut = 3040,
  AgreeOutAccepted = 3045,
  AgreeOutRejected = 3050,
  AgreeNotProcessed = 3055,
  AgreeProcessed = 3060,
  Acquaint = 3500,
  AcquaintAll = 3520,
  AcquaintIn = 3525,
  AcquaintInProcessed = 3530,
  AcquaintOut = 3535,
  AcquaintOutProcessed = 3540,
  AcquaintNotProcessed = 3545,
  AcquaintProcessed = 3550,
  AcquaintNotAccepted = 3555,
  AllProcessed = 3600,
  Favorites = 4000,
  MyFolders = 4500,
  Folder = 4550,
  Archive = 4800,
  Recycle = 5000,
  Organization = 6000,
  OrganizationDepartments = 6100,
  OrganizationRoles = 6200,
  OrganizationUsers = 6300,
  MyOrganisations = 6500,
  OrganizationInvitations = 6600,
  Search = 7000,
  Contragents = 8000,
  Contacts = 9000,
  FileFolders = 10000,
  Utilities = 11000,
  Modules = 12000,
  Administration = 20000,
  Clients = 20100,
  AdminRegistrationKeys = 20200,
  ShablonDocuments = 20300,
  Advertisement = 20400,
  ServiceOrders = 20700,
  Billing = 21000,
  AdminPushNotifications = 21100,
  Blank = 21200,
  AdminReports = 21300,
  AdminDocumentExtendedParams = 21400,
  AdminSystemIntegrity = 21500,
  AdminPromoActions = 21600,
  AdminIitFiles = 21700,
  AdminDictionaries = 21800,
  AdminEducationalPlans = 21900,
  AdminEducationalForms = 22000,
  EduRegistries = 22100,
  EduDocumentRegistries = 22110,
  EduModule = 22199,
  YouControl = 22200,
  AdminSurveys = 22700
}

export enum eDocumentAgreeUserStatusType {
  AGREENEW = 5,
  AGREESEND = 10,
  AGREED = 20,
  NOTAGREED = 30
}

export enum eDocumentSignUserStatus {
  SIGNNEW = 5,
  SIGNSEND = 10,
  SIGNEND = 20,
  SIGNREJ = 30,
  SIGNCANCELLED = 40
}

export enum eDocumentAcquaintUserStatus {
  ACQNEW = 5,
  ACQSEND = 10,
  ACQUAINTED = 20
}

export enum PermissionType {
  ORGDEP = 10,
  MYORG = 20
}

export enum Errors {
  EmailNotConfirmed = 'EmailNotConfirmed',
  Cancelled = 'Cancelled',
  KeyEdrpouMismatch = 'KeyEdrpouMismatch',
  InternalNestedSignatureChangedDuringSigning = 'InternalNestedSignatureChangedDuringSigning'
}

export enum ExceptionType {
  OracleException = 'OracleException',
  PostgresException = 'PostgresException'
}

export enum Languages {
  Ukrainian = 'uk',
  English = 'en',
  Russian = 'ru'
}

export enum NotificationType {
  UserGotDocument,
  AuthorGotDecision,
  DocumentGotNewComment,
  UserGotInvitation,
  InvitationAuthorGotDecision,
  UserDeletedFromOrganization,
  ModuleActivated,
  UserGotReferralBonus,
  UserCancelledDocumentSign,
  DocumentWillBeSentToRegisteredUser,
  NotEnoughFundsToChangeStage
}

export enum PhoneCodes {
  Ukraine = '380'
}

export enum DocumentActionType {
  Acquaint = 'Acquaint',
  Agree = 'Agree',
  Sign = 'Sign'
}

export enum OrgUserInvitationStatus {
  SENT = 10,
  Accepted = 20,
  Rejected = 30,
  Canceled = 40,
  Revoked = 50,
  Deleted = 60
}

export enum PersonalSettingControlType {
  CheckBox = 'CheckBox',
  SelectBox = 'SelectBox'
}

export enum OrganisationSettingsGroup {
  DOCACCESS = 10,
  SIGNVISSETT = 20
}

export enum OrganisationSettingType {
  DenyAccessForUsersWithoutDepartment = 'DOCWDEP',
  UseOrgSettForSignVisualization = 'USEORGSIGNVISSET'
}

export enum UserSettingType {
  MailNotif = 'mailNotif',
  ClientNotif = 'clientNotif',
  Locale = 'locale',
  MultiLogin = 'multiLogin',
  MailNotifComment = 'mailNotifComment',
  AutoLogout = 'autoLogout',
  TgIncoming = 'tgIncoming',
  TgAcquaints = 'tgAcquaints',
  TgSign = 'tgSign',
  TgAgreement = 'tgAgreement',
  DocSignPosType = 'docSignPosType',
  DocSignPosOnPage = 'docSignPosOnPage',
  DisableNotif = 'disableNotif',
  UseUserVisSet = 'useUserVisSet'
}

export enum UserStampType {
  None = 0,
  // Підпис візуалізується я вигляді печатки (Значення по замовчуванню)
  Seal = 1,
  // Підпис візуалізується у вигляді тексту введеного користувачем
  Preset = 2,
  // Текст візуалізується у вигляді зображення, яке намалював користувач
  Image = 3,
  // Підпис візуалізується у вигляді QR коду
  QrCode = 4
}

export enum AppSignType {
  None = 0,
  Sign = 1,
  Stamp = 2
}

export enum SignFileType {
  NotSpecified = 0,
  External = 1,
  Internal = 2,
  InternalNested = 3
}

export enum VisualizationPositionOnPage {
  LeftTop = 0,
  RightTop = 1,
  LeftBottom = 2,
  RightBottom = 3,
}

export enum SignPageOption
{
  None = 0, // No visualize sign
  FirstPage = 1, // Visualize on first page
  LastPage = 2, // Visualize on last page
  AllPage = 3 // Visualize on all pages
}

export enum SignPositionOnPage
{
  AllInLowerLeftCorner = 0,
  AllInLowerRightCorner = 1,
  FirstInLowerLeftCornerAllSubsequentInLowerRightCorner = 2,
  FirstInLowerRightCornerAllSubsequentInLowerLeftCorner = 3,
}

export enum AdvertisementStatus {
  Active = 1,
  NoActive = 2,
  Deleted = 3
}

export enum RegistrationKeyStatus {
  Active = 1,
  Used = 2,
  Deleted = 3
}

export enum eShablonItemType {
  NotSpecified = 0,
  Field = 1,
  Dict = 2,
  UserDict = 3
}

export enum eShablonValueType {
  NotSpecified = 0,
  String = 1,
  Int = 2,
  Decimal = 3,
  Date = 4,
  DateTime = 5,
  Time = 6,
  Memo = 7,
  Boolean = 8
}

export enum eShablonUserDictField {
  Code = 'Code',
  Name = 'Name',
  CodeName = 'CodeName'
}

export enum eShablonReservedFileType {
  MainDoc = 'MAINDOC',
  Pdf = 'PDF',
  Json = 'JSON'
}

export enum AllowedLoginType {
  Email = 'email',
  DigitalSignature = 'digital-signature',
  Google = 'google',
  Facebook = 'facebook',
  Microsoft = 'microsoft',
  Apple = 'apple'
}

export enum ViewDocSettingType {
  agrees = 1,
  discussions = 2,
  edit = 3,
  files = 4,
  history = 5,
  links = 6,
  signs = 7,
  users = 8,
  acquaints = 9,
  actions = 10,
  autorsign = 11,
  annotation = 12,
  signaturesRecall = 13,
  visualizationSettings = 14,
  shablonForm = 15
}

export enum SupportRequestType {
  Request = 0,
  Report = 1
}

export enum PushNotificationStatuses {
  NotSent = 'NotSent',
  SentPartially = 'SentPartially',
  SentAll = 'SentAll',
  FailedPartially = 'FailedPartially',
  FailedAll = 'FailedAll'
}

export enum RecaptchaType {
  Web = 'Web',
  Android = 'Android'
}

export enum RecaptchaProvider {
  Google = 0,
  Cloudflare = 1
}

export enum SignCheckUiMode {
  ReadSign = 0,
  ReadFile = 1,
  VerifyResult = 2
}

export enum AdminClientDocActionType {
  Delete = 'delete',
  Restore = 'restore',
  Destroy = 'destroy'
}

export enum DocumentTransferType {
  FullAccessAndCurrentAuthorRemove = 1,
  ReadonlyAccessAndCurrentAuthorRemove = 2,
  FullAccessAndCurrentAuthorAsReadonly = 3,
  ReadonlyAccess = 4
}

export enum DocumentOwnerType {
  User = 1,
  Organization = 2
}

export enum SignSource {
  File = 'file',
  Device = 'device',
  Cloud = 'cloud'
}

export enum UserTaskStatus {
  AwaitingExecution = 10,
  Executing = 20,
  SuccessfullyCompleted = 30,
  ExecutionError = 40,
  ExecutionCanceled = 50
}

export enum InstructionChapter {
  LoginAndRegistration,
  MainWindow,
  PersonalCabinet,
  OrganizationSettings,
  NavigationPanel,
  DocumentList,
  DocumentView,
  DocumentManagement,
  Folders,
  Tags,
  Instruments,
  WorkWithDocuments,
  CreatignDocument,
  WorkWithDocumentFiles,
  VerificationOfSignatures,
  LinkedDocuments,
  AgreeingOfTheDocument,
  SigningOfTheDocument,
  AcquaintingOfTheDocument
}

export enum EmailStatus {
  NewEmail = 10,
  SendError = 20,
  Sent = 30
}

export enum PromoActionCode {
  NewYear = 'NewYear',
  Christmas = 'Christmas'
}

export enum PromoActionUserStatus {
  Viewed = 1,
  Participated = 2
}

export enum RegistrationType {
  None = 0,
  Email = 1,
  Google = 2,
  Facebook = 3,
  Microsoft = 4,
  MobileId = 5,
  Ecp = 6,
  Rouming = 7,
  Apple = 8
}

export enum ServiceOrderType {
  None,
  Refill = 10,
  PlanChange = 20,
  AdditionalDeliveries = 30,
  ModuleFee = 40
}

export enum AppModuleTariffType {
  None,
  Personal = 1,
  Organisation = 2
}

export enum AppModuleUsageType {
  None,
  IndividualsAndOrganisations = 1,
  Individuals = 2,
  Organisations = 3
}

export enum AppModules {
  Education = 'Education',
  SignAsQrCode = 'SignAsQrCode',
  YouControl = 'YouControl',
}

export enum ReferralStatus {
  None = 0,
  Registered = 10,
  Partner = 20
}

export enum DocumentSignRecallStatus {
  InProgress = 10,
  Recalled = 20,
  Rejected = 30
}

export enum DocumentVisualizationSettingType {
  DocumentSettings = 0,
  UserSettings = 1,
  FileSettings = 2
}

export enum CountType {
  Pay = 10,
  TpDelivery = 20,
  AddDelivery = 30,
  Modules = 40
}

export enum RouterView {
  AccountRestore = 'accountRestore',
  AdminClientInvitations = 'adminClientInvitations',
  AdminClientStatistic = 'adminClientStatistic',
  AdminDictionaries = 'adminDictionaries',
  AdminDictionaryView = 'adminDictionaryView',
  AdminDocumentExtParams = 'adminDocumentExtParams',
  AdminDocumentTypeEdit = 'adminDocumentTypeEdit',
  AdminDocumentTypes = 'adminDocumentTypes',
  AdminIitFiles = 'adminIitFiles',
  AdminOrgUsers = 'adminOrgUsers',
  AdminPromoActions = 'adminPromoActions',
  AdminPromoActionDetails = 'adminPromoActionDetails',
  AdminPromoActionCreate = 'adminPromoActionCreate',
  AdminReports = 'adminReports',
  AdminSystemIntegrity = 'adminSystemIntegrity',
  AdminUserDetails = 'adminUserDetails',
  AdminSurveys = 'adminSurveys',
  AdminSurveyDetails = 'adminSurveyDatails',
  Clients = 'clients',
  ClientDetails = 'clientDetails',
  ClientNew = 'clientNew',
  ConfirmEmail = 'confirmEmail',
  ConfirmEmailUserOrg = 'confirmEmailUserOrg',
  ConfirmRemoveAccount = 'confirmRemoveAccount',
  ConfirmRestoreAccount = 'confirmRestoreAccount',
  DocumentAdd = 'documentAdd',
  EducationDictionaries = 'educationDictionaries',
  EducationDictionaryView = 'educationDictionaryView',
  EducationDocumentRegistries = 'educationDocumentRegistries',
  EducationForms = 'educationForms',
  EducationPlans = 'educationPlans',
  EducationRegistries = 'educationRegistries',
  Home = 'home',
  Invitations = 'invitations',
  Login = 'login',
  MyOrganisations = 'myorganisations',
  Notifications = 'notifications',
  OrgInvitations = 'orgInvitations',
  OrgSignVisSettings = 'orgSignaturesVisualizationSettings',
  Registration = 'registration',
  RegistrationCompletion = 'registrationCompletion',
  RegistrationConfirm = 'registrationConfirm',
  RestorePass = 'restorePass',
  RestorePassConfirm = 'restorePassConfirm',
  Root = 'root',
  RoumingLogin = 'rouminglogin',
  RoumingReg = 'roumingreg',
  SignFiles = 'signFiles',
  Stamps = 'stamps',
  ViewDoc = 'viewdoc',
  ViewDocUnregUser = 'viewDocUnregUser',
  UtilityInternalSignatures = 'internalSignatures',
  YouControl = 'YouControl'
}

export enum AppHttpHeaders {
  ServerVersion = 'ao-server-version',
  ServerTime = 'ao-server-time',
  SignLibFilesVersion = 'ao-sign-lib-files-version',
  UnregUserToken = 'x-ao-unreg-user-token',
  RecaptchaType = 'x-ao-recaptcha-type',
  RecaptchaToken = 'x-ao-recaptcha-token'
}

export enum UnregUserActionPanels {
  None = 0,
  Processing = 1,
  DocumentInfo = 2,
  TechSupport = 3,
  Signatures = 4
}

export enum RoleType {
  None = 0,
  Admin = 10,
  OrganizationAdmin = 15,
  User = 20,
  OrganizationUser = 25,
  OrganisationExchangeOperator = 30,
  SystemAdmin = 100,
  SecurityAdmin = 110,
  ReportsAdministrator = 120
}

export enum LoginType {
  Email = 'email',
  DigitalSignature = 'digital-signature',
  Google = 'google',
  Facebook = 'facebook',
  Microsoft = 'microsoft',
  Apple = 'apple',
}

export enum Permissions {
  NONE = 0,
  SOADD = 10570,
  ORGUSGET = 11000,
  ORGUSADD = 11010,
  ORGDEPGET = 11040,
  ORGROLGET = 11080,
  MYORGGET = 11830,
  ORGUSERINVG = 11900,
  ORGCONTRGET = 12700,
  TRANSFERDOCTOORG = 13100,
  ORGSETTGET = 13200,
  ORGSETTEDIT = 13210,
  ORGABLANKSGET = 13300,
  ORGADMSHTGET = 13500,
  ORGADMSHADGET = 13540,
  MODULESUSE = 13800,
  MODULESACTIVATE = 13810,
  ORGVISSETTGET = 14700,
  ORGVISSETTEDIT = 14710,
  EDU_DICTIONARY_GET = 14800,
  EDU_DICTIONARY_EDIT = 14810,
  EDU_PLANS_GET = 14900,
  EDU_PLANS_EDIT = 14910,
  EDU_FORMS_GET = 15000,
  EDU_FORMS_EDIT = 15010,
  EDU_REGISTRY_GET = 15100,
  EDU_REGISTRY_EDIT = 15110,
  A_CLIENTDEL = 20330,
  A_USERSGET = 20400,
  A_REGTOKENGET = 20600,
  A_ORDERGET = 20700,
  A_SHTGET = 20800,
  A_SHTADD = 20810,
  A_SHADGET = 20840,
  A_SHADADD = 20850,
  A_ADVGET = 20900,
  A_BILLINGGET = 21010,
  A_PUSHSEND = 21100,
  A_REPORTS = 21300,
  A_CLIENTINVITE = 21800,
  A_DOCPARAMGET = 21900,
  A_INTEGRITYGET = 22100,
  A_ORGADD = 22200,
  A_ORGUSERADD = 22210,
  A_ORGNAMECHANGE = 22220,
  A_ORGUSERTRANSFER = 22230,
  A_PROMOACTIONGET = 22300,
  A_PROMOACTIONADD = 22310,
  A_IITFILESGET = 22400,
  A_IITFILESUPDATE = 22410,
  A_ORGIMPORT = 22500,
  A_DICTIONARY_GET = 22600,
  A_DICTIONARY_EDIT = 22610,
  A_SURVEY_GET = 22700,
  A_SURVEY_EDIT = 22710
}

export enum AdminReportType {
  None = 0,
  ActiveSessions = 1,
  CreatedDocuments = 2,
  SentDocuments = 3,
  ProcessingDocuments = 4,
  Registrations = 5,
  Documents = 6
}

export enum DocumentSignaturesListMode {
  Default = 0,
  File = 1,
  User = 2
}

export enum SigningMethod {
  NotSpecified = 0,
  AskodOnline = 1,
  ExternalSystem = 2,
  AddedManually = 3
}
